export type OperatorArity = "none" | "single" | "multiple" | "exactly-two";

export interface OperatorSpec {
  operator: string;
  arity: OperatorArity;
}

// Source: Dataverse FetchXML operator reference (official docs)
export const DATAVERSE_OPERATOR_SPECS: OperatorSpec[] = [
  { operator: "above", arity: "single" },
  { operator: "begins-with", arity: "single" },
  { operator: "between", arity: "exactly-two" },
  { operator: "contain-values", arity: "multiple" },
  { operator: "ends-with", arity: "single" },
  { operator: "eq", arity: "single" },
  { operator: "eq-businessid", arity: "none" },
  { operator: "eq-or-above", arity: "single" },
  { operator: "eq-or-under", arity: "single" },
  { operator: "eq-userid", arity: "none" },
  { operator: "eq-userlanguage", arity: "none" },
  { operator: "eq-useroruserhierarchy", arity: "none" },
  { operator: "eq-useroruserhierarchyandteams", arity: "none" },
  { operator: "eq-useroruserteams", arity: "none" },
  { operator: "eq-userteams", arity: "none" },
  { operator: "ge", arity: "single" },
  { operator: "gt", arity: "single" },
  { operator: "in", arity: "multiple" },
  { operator: "in-fiscal-period", arity: "single" },
  { operator: "in-fiscal-period-and-year", arity: "exactly-two" },
  { operator: "in-fiscal-year", arity: "single" },
  { operator: "in-or-after-fiscal-period-and-year", arity: "exactly-two" },
  { operator: "in-or-before-fiscal-period-and-year", arity: "exactly-two" },
  { operator: "last-fiscal-period", arity: "none" },
  { operator: "last-fiscal-year", arity: "none" },
  { operator: "last-month", arity: "none" },
  { operator: "last-seven-days", arity: "none" },
  { operator: "last-week", arity: "none" },
  { operator: "last-x-days", arity: "single" },
  { operator: "last-x-fiscal-periods", arity: "single" },
  { operator: "last-x-fiscal-years", arity: "single" },
  { operator: "last-x-hours", arity: "single" },
  { operator: "last-x-months", arity: "single" },
  { operator: "last-x-weeks", arity: "single" },
  { operator: "last-x-years", arity: "single" },
  { operator: "last-year", arity: "none" },
  { operator: "le", arity: "single" },
  { operator: "like", arity: "single" },
  { operator: "lt", arity: "single" },
  { operator: "ne", arity: "single" },
  { operator: "ne-businessid", arity: "none" },
  { operator: "ne-userid", arity: "none" },
  { operator: "neq", arity: "single" },
  { operator: "next-fiscal-period", arity: "none" },
  { operator: "next-fiscal-year", arity: "none" },
  { operator: "next-month", arity: "none" },
  { operator: "next-seven-days", arity: "none" },
  { operator: "next-week", arity: "none" },
  { operator: "next-x-days", arity: "single" },
  { operator: "next-x-fiscal-periods", arity: "single" },
  { operator: "next-x-fiscal-years", arity: "single" },
  { operator: "next-x-hours", arity: "single" },
  { operator: "next-x-months", arity: "single" },
  { operator: "next-x-weeks", arity: "single" },
  { operator: "next-x-years", arity: "single" },
  { operator: "next-year", arity: "none" },
  { operator: "not-begin-with", arity: "single" },
  { operator: "not-between", arity: "exactly-two" },
  { operator: "not-contain-values", arity: "multiple" },
  { operator: "not-end-with", arity: "single" },
  { operator: "not-in", arity: "multiple" },
  { operator: "not-like", arity: "single" },
  { operator: "not-null", arity: "none" },
  { operator: "not-under", arity: "single" },
  { operator: "null", arity: "none" },
  { operator: "olderthan-x-days", arity: "single" },
  { operator: "olderthan-x-hours", arity: "single" },
  { operator: "olderthan-x-minutes", arity: "single" },
  { operator: "olderthan-x-months", arity: "single" },
  { operator: "olderthan-x-weeks", arity: "single" },
  { operator: "olderthan-x-years", arity: "single" },
  { operator: "on", arity: "single" },
  { operator: "on-or-after", arity: "single" },
  { operator: "on-or-before", arity: "single" },
  { operator: "this-fiscal-period", arity: "none" },
  { operator: "this-fiscal-year", arity: "none" },
  { operator: "this-month", arity: "none" },
  { operator: "this-week", arity: "none" },
  { operator: "this-year", arity: "none" },
  { operator: "today", arity: "none" },
  { operator: "tomorrow", arity: "none" },
  { operator: "under", arity: "single" },
  { operator: "yesterday", arity: "none" },
];

export const DATAVERSE_OPERATOR_MAP: ReadonlyMap<string, OperatorSpec> = new Map(
  DATAVERSE_OPERATOR_SPECS.map((item) => [item.operator, item]),
);

export const VALUEOF_COMPARISON_OPERATORS = new Set(["eq", "ne", "gt", "ge", "lt", "le"]);
